import { render, staticRenderFns } from "./BrokersFilter.vue?vue&type=template&id=ffc7e042&scoped=true"
import script from "./BrokersFilter.vue?vue&type=script&lang=js"
export * from "./BrokersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc7e042",
  null
  
)

export default component.exports